export default {"src":"/_next/static/media/instagram.d0a61bd7.svg","height":132,"width":132};